module.exports = __webpack_public_path__ + "img/dc_03.f5fdc628.jpg";